/*
 * File: /src/components/SectionCategories.1.vue
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 17th August 2018 1:02:07 pm
 * Last Modified: Thursday, 23rd August 2018 1:20:00 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
<template>
  <div class="section-categories" :class="{ 'section-categories--list-layout': listLayout }">
    <ul class="section-categories__list" v-if="categories && categories.length">
      <li class="li" v-for="category in categories" :key="category.id">
        <BaseLink class="category" :to="category.to">
          <div class="category__icon">
            <BaseIcon :name="category.icon"/>
          </div>
          <label>{{ category.name }} </label>
        </BaseLink>
        <div>
          <router-link class="edit-link" :to="category.editUrl">Edit custom objects</router-link>
          <BaseButton class="buttons__btn" icon="trash" @click.native="openConfirmDeleteModal(category.id)"/>
        </div>
      </li>
      <li v-if="!categories || !categories.length">
        <h1 class="alert alert__title">You don’t have any custom objects yet</h1>
        <h2 class="alert alert__subtitle">Your custom objects will be shown here once you have created your first one.</h2>
      </li>
    </ul>
    <slot name="button"></slot>
  </div>
</template>

<script>
  import { MDSModalConfirmDecisionModel } from '@/models/modal-datasets.model'
  
  export default {
    props: {
      categories: Array,
      listLayout: Boolean,
    },

    methods: {
      async onDelete(id) {
        await this.$store.dispatch('shopCustomobjectsgroupsList/REMOVE_CUSTOM_OBJECT_GROUP', { id })
      },
      openConfirmDeleteModal (id) {
        const props = new MDSModalConfirmDecisionModel({
          confirmationHandler: () => this.onDelete(id)
        })
        this.$store.commit('modals/OPEN_MODAL', { name: 'ModalConfirmDecision', props })
      }
    }
  }
</script>

<style lang="scss">
  @import './src/assets/styles/colors.scss';
  @import './src/assets/styles/breakpoints.scss';

  .section-categories {
    width: 668px;
    background-color: $color-white;
    border-radius: 3px;
    overflow: hidden;
    box-shadow: 0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15);

    @include media(ltTablet) {
      width: 100%;
    }

    &:not(:last-of-type) {
      margin-bottom: 20px;
    }
  }

  .section-categories .new-field-button {
    border-right: none;
    border-bottom: none;
    border-left: none;
  }

  .section-categories__list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 16px;

    li {
      width: 100%;
    }
    
    li.li {
      flex-shrink: 0;
      width: calc(50% - 10px);

      @include media(ltMobile) {
        width: 100%;
      }
    }

    .category {
      display: flex;
      align-items: center;
      padding: 12px;
      border-radius: 3px;

      &:hover {
        background-color: $color-athens-gray;

        .category__icon {
          background-color: $color-geyser;
        }
      }
      
      label {
        margin-left: 16px;
        font-size: 14.6px;
        font-weight: 600;
        cursor: pointer;
      }

      &__icon {
        padding: 10px;
        background-color: $color-athens-gray;
        border-radius: 3px;

        svg {
          width: 20px;
          height: 20px;
          color: $color-regent-gray;
        }
      }
    }

    .alert {
      width: 100%;
      text-align: center;

      &__title {
        margin-top: 10px;
        color: $color-ebony-clay;
        font-size: 19px;
        font-weight: 500;
        line-height: 1.33;
      }

      &__subtitle {
        margin-top: 16px;
        margin-bottom: 10px;
        color: $color-pale-sky;
        font-size: 14.6px;
        line-height: 1.28;
      }
    }
  }

  .section-categories--list-layout {
    display: block;

    li.li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      .category {
        width: calc(50% - 10px);
      }

      .edit-link {
        font-size: 14.6px;
        text-decoration: underline;
        margin-right: 10px;

        &:hover {
          text-decoration: none;
        }

        &:focus {
          outline: 2px solid $color-purple;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/SectionCustomObjectsGroups.vue